import { encodeQueryParams } from "../utils/url";
import { decodeToken } from "react-jwt";

require("dotenv").config({ path: "../../.env" });

const apicall = (action, path, method, body) => dispatch => {
  dispatch({ type: action + "_FETCHING" });
  //console.log(path);
  const idToken = window.sessionStorage.idToken;
  const headers = {
    "x-access-token": window.sessionStorage.accessToken,
    "Content-Type": "application/json",
    // Fix for IE11. Without Pragma: no-cache IE11 will cache all requests based on browser settings.
    Pragma: "no-cache",
    Accept: "application/json"
  }
  if (idToken) {
    const userInfo = decodeToken(idToken);
    if (userInfo) {
      headers["x-user-firstname"] = userInfo.given_name;
      headers["x-user-lastname"] = userInfo.family_name;
    }
  }
  dispatch(
    fetch("/api/" + path, {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined
    })
      .then(response =>
        response.json().then(data => {
          return {
            data: data,
            status: response.status,
            ok: response.ok,
            response
          };
        })
      )
      .then(response => {
        if (response.response.headers.get("x-access-token")) {
          window.sessionStorage.accessToken = response.response.headers.get(
            "x-access-token"
          );
        }
        //console.log(response.status);
        switch (response.status) {
          case 200:
            return {
              type: action + "_RESULT",
              payload: response.data
            };
          case 400:
            return {
              type: action + "_ERROR",
              payload: response.data
            };
          case 401:
            /* Auth token is invalid or has expired */
            window.sessionStorage.clear();
            window.location.href = "/";
            return {
              type: "AUTH_UNAUTHORIZED"
            };
          case 404:
            return {
              type: action + "_ERROR",
              payload: response.data
            };
          case 500:
            return {
              type: "API_ERROR",
              payload: response.status
            };
          default:
            //console.warn("Unhandled response code", response);
            return {
              type: "API_ERROR",
              payload: "Internal error: unknown API response code"
            };
        }
      })
      .catch((error, response) => {
        //TODO: Maybe there is a better way to do this?
        /* Auth token is invalid or has expired */
        window.sessionStorage.clear();
        window.location.href = "/";
        return {
          type: "AUTH_UNAUTHORIZED"
        };
        /*
      return {
          type: 'API_ERROR',
          payload: 'An error occurred while contacting the server!'
      }
      */
      })
  );
};

export function Get(action, path, params = {}) {
  return apicall(action, path + encodeQueryParams(params), "GET", null);
}

export function Post(action, path, body) {
  return apicall(action, path, "POST", body);
}

export function Put(action, path, body) {
  return apicall(action, path, "PUT", body);
}

export function Delete(action, path) {
  return apicall(action, path, "DELETE", null);
}

/**
 * This function is used for getting the content from the wordpress API
 * @param {*} action
 * @param {*} path
 * @param {*} method
 * @param {*} body
 */
const WPapicall = (action, page_id, method, body) => dispatch => {
  dispatch({ type: action + "_FETCHING" });
  dispatch(
    fetch(process.env.REACT_APP_WP_API_URL + page_id, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: body ? JSON.stringify(body) : undefined
    })
      .then(response => {
        switch (response.status) {
          case 200:
            return {
              type: action + "_RESULT",
              payload: response.json()
            };
          case 400:
            return {
              type: action + "_ERROR",
              payload: response.json()
            };
          case 401:
            return {
              type: action + "_ERROR",
              payload: response.json()
            };

          default:
            //console.warn("Unhandled response code", response);
            return {
              type: "API_ERROR",
              payload: "Internal error: unknown API response code"
            };
        }
      })
      .catch(error => {
        //console.warn(action, "API error", error);
        return {
          type: "API_ERROR",
          payload: "An error occurred while contacting the server!"
        };
      })
  );
};

// Used for getting information from wordpress API
export function WPGet(action, id) {
  return WPapicall(action, id, "GET", null);
}



// WEBPACK FOOTER //
// ./src/api/index.js